<template>
  <div>
    <div class="log-wrapper">
      <img src="../../assets/img/logo.svg" alt="">
    </div>
    <div class="form-wrapper">
      <n-input v-model="user.email"
        :placeholder="lang[0]"
        type="text"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
      >
      </n-input>
      <n-input v-model="user.password"
        :placeholder="lang[1]"
        type="password"
        class="nerz-input-unauth input floating-placeholder-unauth placeholder-unauth"
      >
      </n-input>
      <div class="btn-wrapper">
        <btn class="sign_up" :label="lang[2]" type="white" size="normal" @click="signup()"></btn>
        <btn class="sign_in" :label="lang[3]" type="primary" size="normal" @click="login()" :loading="loading"></btn>
      </div>
      <div class="password-reset">
        <router-link to="/reset-mail">
          <p>forget password?</p>
        </router-link>
      </div>
    </div>
    <div class="login-back">
      <img src="../../assets/img/nazuna-top.png" class="nazuna-img" alt="">
    </div>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</template>

<script>
/* ============
 * Login Index Page
 * ============
 *
 * Page where the user can login.
 */

import btn from '../../components/Button.vue';
import notice from '../../components/Notice.vue';
import axios from 'axios';
import NInput from '../../components/Input.vue'
import LoginLangMaster from '../../masters/langMaster/LoginLangMaster.js'

export default {
  /**
   * The name of the page.
   */
  name: 'Login',

  /**
   * The components the page can use.
   */
  components: {
    btn,
    notice,
    NInput,
  },

  /**
   * The data that can be used by the page.
   *
   * @returns {Object} The view-model data.
   */
  data() {
    return {
      user: {
        email: null,
        password: null,
      },
      isNotice: false,
      noticeText: '',
      noticeTitle: '',
      noticeType: '',
      loading: false,
      lang: {},
    };
  },

  created(){
    if(navigator.language  === "ja") {
      this.lang = LoginLangMaster['ja'];
    } else {
      this.lang = LoginLangMaster['en'];
    }
    // Auto Login
    var localData = localStorage.getItem('nerzex.login')
    if(localData != null){
      this.localUserLoginData = JSON.parse(localData)
      axios.post('public/login', this.localUserLoginData)
      .then((data) => {
        const userData = data.data.user
        userData.token = data.data.token
        this.$store.dispatch('auth/login', userData)
      }).catch((err) => {
        console.log(err);
      });
    }
    else{
      // Do nothing
    }
  },

  methods: {
    login() {
      this.isNotice = false
      this.loading = true
      localStorage.setItem('nerzex.login',JSON.stringify(this.user))
      axios.post('public/login', this.user)
      .then((data) => {
        const userData = data.data.user
        userData.token = data.data.token
        this.$store.dispatch('auth/login', userData)
        if(localStorage.getItem('nerzex.appState.registerSource')) {
          this.$router.push(localStorage.getItem('nerzex.appState.registerSource'))
          localStorage.removeItem('nerzex.appState.registerSource')
        }
      }).catch((err) => {
        console.log(err);
        this.noticeType = 'alert'
        this.noticeTitle = 'Error'
        this.noticeText = err.response.data.msg
        this.isNotice = true
        this.loading = false
      });
    },

    signup() {
      this.$router.push('/register')
    },
  },
};
</script>

<style scoped>
.login-back {
  background: #F39939;
  filter: blur(10px) saturate(70%);
  position: absolute;
  z-index: -1;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  overflow: hidden;
}

.log-wrapper {
  width: 98%;
  max-width: 500px;
  margin: auto;
  margin-top: 20%;
}

.log-wrapper img {
  width: 100%;
}

.form-wrapper {
  width: 98%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btn-wrapper {
  display: flex;
  justify-content: space-around;
}

.btn-wrapper button {
  margin: 10px;
}

.input {
  appearance: none;
  border: none;
  border-bottom: 1px solid #fff;
  color: #fff;
  font-size: 15px;
  background: transparent!important;
  display: block;
  width: 90%;
  margin: 5% auto;
}

input::placeholder {
  color: #fff;
}

.form-wrapper input:-internal-autofill-selected {
  background-color: transparent!important;
}

.nazuna-img {
  position: absolute;
  bottom: 0%;
  right: -20%;
  width: 70%;
}

::placeholder{
   opacity: 0.5;
}

input:-webkit-autofill {
  color: #fff;
  /* ここで指定しているbackground-colorは黄色い背景色のことです */
  -webkit-transition: background-color 9999s;
  transition: background-color 9999s;
}

.nerz-input-unauth >>> .nerz-input {
  width: 100%;
  margin: auto;
  line-height: 1;
  padding: 10px 5px;
  font-size: 16px;
  appearance: none;
  border: none;
  background: transparent!important;
  padding-top: 0;
  color: white;
}

.floating-placeholder-unauth >>> .floating-placeholder {
  font-size: 12px;
  line-height: 0;
  margin-block-end: 0px;
  margin-bottom: 5px!important;
  margin-left: 5px;
  color: white;
  font-weight: bold;
}

.placeholder-unauth ::placeholder {
  font-size: 14px;
  color: #ffffff5c;
}

.password-reset {
    margin: 20px 20px 0 20px;
    font-size: 14px;
    color: #0075c2;
    width: fit-content;
}

@media screen and (min-width: 600px){
  .log-wrapper {
    margin-top: 10%;
    margin-left: 10%;
  }

  .input{
    font-size: 20px;
  }

  .form-wrapper{
    width:50%;
    left:33%;
  }

  .btn-wrapper{
    justify-content: center;
  }

  .sign_in {
    margin-left: 5%;
  }
}

</style>
